module.exports = __webpack_public_path__ + "static/media/06.99492839.jpg";